// A callback that keeps one identity for the component's life but always runs the newest code. Needed for the
// kit's OTPInput: it calls `onComplete` from an effect that re-runs whenever `onComplete` changes, so a new function
// on every render submits a full code again and again (kit gap K7, reminder 72).
import { useCallback, useLayoutEffect, useRef } from 'react'

export function useStableCallback<Args extends unknown[]>(
  callback: (...args: Args) => void
): (...args: Args) => void {
  const latest = useRef(callback)
  useLayoutEffect(() => {
    latest.current = callback
  })
  return useCallback((...args: Args) => latest.current(...args), [])
}
